import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import store from './redux/MyStore';
import AuthenticationProvider from "./Providers/AuthenticationProvider";
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    {/* <PayPalScriptProvider options={{ "client-id": "AfHssuQd-igtuQLQ9VZ73ju2aIcrxWPLv2JZZ7FDBYNzKdn6WX406ln46kIFw6ILZGBLzFL49kgDQOTC" }} deferLoading={false}> */}
      <Provider store={store}>
        <BrowserRouter>
          <AuthenticationProvider>
            <App />
          </AuthenticationProvider>
        </BrowserRouter>
      </Provider>
    {/* </PayPalScriptProvider> */}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
